import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import MapIcon from '@mui/icons-material/Map';
import Tooltip from '@mui/material/Tooltip';
import IconButton from 'components/@extended/IconButton';
import useHeaderTheme from 'hooks/useHeaderTheme';

export default function MapShorCut() {
  const navigate = useNavigate();
  const { iconColor, hoverColor } = useHeaderTheme();

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title="Maps Monitoring">
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: iconColor,
            bgcolor: 'transparent',
            '&:hover': { bgcolor: hoverColor },
            ...theme.applyStyles('dark', { bgcolor: 'transparent' })
          })}
          aria-label="map shortcut"
          onClick={() => navigate('/maps-monitoring?name=maps-monitoring')}
        >
          <MapIcon sx={{ color: iconColor }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
